var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "width": "650px",
      "temporary": "",
      "right": ""
    },
    model: {
      value: _vm.importData.isNavOpen,
      callback: function ($$v) {
        _vm.$set(_vm.importData, "isNavOpen", $$v);
      },
      expression: "importData.isNavOpen"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto"
  }, [_c('v-card-title', [_vm._v(" Import Specimen Data ")]), _c('v-card-text', [_c('v-file-input', {
    attrs: {
      "label": "Upload Biobank Data",
      "type": "file",
      "outlined": "",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onFileChange
    },
    model: {
      value: _vm.file,
      callback: function ($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "items": _vm.specimenSourceItems,
      "item-value": "code",
      "item-text": "label",
      "outlined": "",
      "dense": "",
      "label": "Specimen Source (if applicable)",
      "placeholder": "Select Specimen Source"
    },
    model: {
      value: _vm.selectSpecimenSource,
      callback: function ($$v) {
        _vm.selectSpecimenSource = $$v;
      },
      expression: "selectSpecimenSource"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "items": _vm.projectCodeItems,
      "item-value": "code",
      "item-text": "label",
      "outlined": "",
      "dense": "",
      "label": "Project Code",
      "placeholder": "Select Project Code"
    },
    model: {
      value: _vm.selectProjectCode,
      callback: function ($$v) {
        _vm.selectProjectCode = $$v;
      },
      expression: "selectProjectCode"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "items": _vm.projectCodeFormItems,
      "item-value": "code",
      "item-text": "label",
      "outlined": "",
      "dense": "",
      "label": "Select Form (if applicable)",
      "placeholder": "Select Form",
      "disabled": !_vm.selectProjectCode
    },
    model: {
      value: _vm.selectProjectCodeForm,
      callback: function ($$v) {
        _vm.selectProjectCodeForm = $$v;
      },
      expression: "selectProjectCodeForm"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.file || !_vm.selectProjectCode || !_vm.selectSpecimenSource
    },
    on: {
      "click": _vm.proceedImport
    }
  }, [_vm._v(" Import ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }